module.exports = __webpack_public_path__ + "img/esteelauder_logo.11d1765c.png";